import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semibold mb-2 d-block" }, "Platform", -1)
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semibold mb-2 d-block" }, " Tickets (MT4) / Deals (MT5) ", -1)
const _hoisted_5 = { class: "fs-8 text-gray-500 mt-1" }
const _hoisted_6 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-semibold me-3 mb-0" }, "Force", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-gray-500 ms-3" }, " On: bypass dedup and resend. Off: only send trades not sent before. ", -1)
const _hoisted_9 = {
  key: 0,
  class: "mt-5 p-4 rounded bg-light-primary fs-6"
}

import { ref, computed } from "vue";
import RebateService from "../services/RebateService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { ServiceTypes } from "@/core/types/ServiceTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTradesModal',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {



const dialogVisible = ref(false);
const isLoading = ref(false);
const serviceId = ref<number>(ServiceTypes.MetaTrader4Co);
const ticketsText = ref("");
const force = ref(true);
const result = ref<any>(null);

const parsedTickets = computed(() =>
  ticketsText.value
    .split(/[\s,]+/)
    .map((item) => item.trim())
    .filter((item) => item !== "")
    .map((item) => Number(item))
    .filter((item) => Number.isInteger(item) && item > 0)
);

const show = () => {
  serviceId.value = ServiceTypes.MetaTrader4Co;
  ticketsText.value = "";
  force.value = true;
  result.value = null;
  isLoading.value = false;
  dialogVisible.value = true;
};

const hide = () => {
  dialogVisible.value = false;
};

const submit = async () => {
  if (parsedTickets.value.length === 0) return;
  isLoading.value = true;
  result.value = null;
  try {
    const res = await RebateService.manualEnqueueTradeRebate({
      serviceId: serviceId.value,
      tickets: parsedTickets.value,
      force: force.value,
    });
    result.value = res;
    MsgPrompt.success(
      `Requested: ${res.requested}, Enqueued: ${res.enqueued}, Skipped: ${res.skipped}`
    );
    emits("refresh");
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
    title: "Add Trades",
    width: "600px",
    "append-to-body": "",
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: hide,
        disabled: isLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit,
        loading: isLoading.value,
        disabled: parsedTickets.value.length === 0
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_select, {
            modelValue: serviceId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serviceId).value = $event)),
            class: "w-100"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('type.platform.20'),
                value: _unref(ServiceTypes).MetaTrader4Co
              }, null, 8, ["label", "value"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('type.platform.30'),
                value: _unref(ServiceTypes).MetaTrader5
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_el_input, {
            modelValue: ticketsText.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ticketsText).value = $event)),
            type: "textarea",
            rows: 5,
            placeholder: "Enter ticket / deal numbers, separated by comma, space or new line"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(parsedTickets.value.length) + " valid number(s) ", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_switch, {
            modelValue: force.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((force).value = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_8
        ]),
        (result.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", null, "Requested: " + _toDisplayString(result.value.requested), 1),
              _createElementVNode("div", null, "Enqueued: " + _toDisplayString(result.value.enqueued), 1),
              _createElementVNode("div", null, "Skipped: " + _toDisplayString(result.value.skipped), 1)
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})